import React, { useState, useCallback, useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import NavMenu from './NavMenu.shadcn';
import Header from './Header.shadcn';
import {
  Sheet,
  SheetContent,
  SheetHeader,
  SheetTitle,
} from '../components/ui/sheet';

/**
 * AppShell - Main application layout with navigation drawer
 * Provides consistent header, navigation, and footer across all pages
 */
export default function AppShell() {
  const [isNavOpen, setIsNavOpen] = useState(true);
  const [isMobileNavOpen, setIsMobileNavOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(typeof window !== 'undefined' ? window.innerWidth < 768 : false);

  // Track window size for responsive behavior
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const toggleNav = useCallback(() => {
    // On mobile, toggle the overlay drawer
    if (isMobile) {
      setIsMobileNavOpen(prev => !prev);
    } else {
      // On desktop, toggle inline drawer
      setIsNavOpen(prev => !prev);
    }
  }, [isMobile]);

  const closeMobileNav = useCallback(() => {
    setIsMobileNavOpen(false);
  }, []);

  return (
    <div className="flex flex-col h-screen overflow-hidden">
      <Header onMenuClick={toggleNav} />
      
      <div className="flex flex-1 overflow-hidden">
        {/* Desktop inline drawer */}
        {isNavOpen && !isMobile && (
          <aside className="w-60 flex-shrink-0 border-r bg-card overflow-y-auto">
            <NavMenu onNavigate={() => {}} />
          </aside>
        )}

        {/* Mobile overlay drawer using Sheet */}
        <Sheet open={isMobileNavOpen} onOpenChange={setIsMobileNavOpen}>
          <SheetContent side="left" className="w-72 p-0">
            <SheetHeader className="p-4 border-b">
              <SheetTitle>Navigation</SheetTitle>
            </SheetHeader>
            <NavMenu onNavigate={closeMobileNav} />
          </SheetContent>
        </Sheet>

        {/* Main content area - React Router renders page here */}
        <main className="flex-1 overflow-auto flex flex-col">
          <Outlet />
        </main>
      </div>

      <footer className="py-2 px-4 text-center bg-muted border-t text-xs text-muted-foreground">
        © 2024-2026 Gardeno Games. Ultraman Card Game is a trademark of Tsuburaya Productions.
      </footer>
    </div>
  );
}
